// const sleepOrderItemClick = require('OrdercenterCommon/sleepOrderItemClick.js');

const disableMap: { [propName: string]: boolean } = {
    2030: true,
    2040: true,
    900010: true
};

const fixPrice = (price: string, currency = '') => {
    // 如果不传currency，默认按照外币处理，防止发生样式问题
    const newCurrency = (currency || '').trim();
    if(!price){
        return;
    }
    let originPrice = Number(price).toString();
    if (!originPrice || Number(originPrice) <= 0) {
        return;
    }
    const isForeignCurrency = newCurrency !== '&yen;';
    const isFloat = Number(originPrice) % 10000 > 0;
    if (originPrice) {
        if (Number(originPrice) >= 1000000000000) {
            // 1亿
            originPrice = '9999万+';
        } else if (Number(originPrice) >= 100000000 && isForeignCurrency && isFloat) {
            // 小数点加外币 1w
            originPrice = `${parseInt(String(Number(originPrice) / 100000000), 10)}万+`;
        } else if (Number(originPrice) >= 1000000000) {
            // 非小数点加外币 10W +
            originPrice = `${parseInt(String(Number(originPrice) / 100000000), 10)}万+`;
        } else {
            originPrice = `${parseInt(String(Number(originPrice) / 100), 10)}`;
            originPrice = String(Number(originPrice) / 100);
        }
    }
    return originPrice?.toString() || price;
};
const buildDateTime = (dateTime: string) => {
    const date = dateTime || '';
    const info = date.split(' ') || [];
    const len = info.length;
    if (info[len - 1]) {
        info[len - 1] = info[len - 1].slice(0, 5);
    }
    return info.join(' ');
};
const buildActionInfos = (
    appActions: any[] = [],
    btnHighLightMap: { [propName: string]: boolean } = {}
) => {
    const result: any[] = [];

    appActions.forEach((action) => {
        let { actionName } = action;
        const { title, type, phone, schema, url } = action;
        // actionName = actionName.toLowerCase();
        if (title && type === 'phonecall' && phone) {
            result.push({
                title,
                phone,
                isHighLight: btnHighLightMap[actionName],
                actionType: 'phonecall',
                schema
            });
        } else if (title && (schema || url) && actionName !== 'detail') {
            result.push({
                title,
                actionName,
                schema,
                url,
                isSchema: Boolean(schema),
                isHighLight: btnHighLightMap[actionName],
                actionType: 'openview'
            });
        }
    });
    return result;
};
const checkDisable = (status: string) => {
    return disableMap[status];
};
const getDetailSchema = (appAction: any[] = []) => {
    const len = appAction.length;
    for (let i = 0; i < len; i++) {
        const { schema, url, hintText, actionName = '', title } = appAction[i];
        if (actionName.toLowerCase() === 'detail') {
            return {
                title,
                url,
                schema,
                isSchema: Boolean(schema),
                detailHint: hintText
            };
        }
    }
};
const buildTimeLine = (departure: string, arrival: string, joiner?: string) => {
    let arrivalInfo;
    const timeLine = [];
    if (departure && arrival) {
        timeLine.push(departure.trim().slice(0, -3));
        arrivalInfo = arrival.trim().split(' ');
        timeLine.push(arrivalInfo?.[1]?.slice(0, -3) || '');
    }
    return timeLine.join(joiner || ' - ');
};

const buildFuzzyTimeLine = (showDeparture: string, showArrival: string) => {
    if (showDeparture && showArrival) {
        return `${showDeparture} - ${showArrival}`;
    }
    if (showDeparture) {
        return showDeparture;
    }
    return ''
}

const parseStr = (dateStr: string, spliter = '-') => {
    const _str = dateStr;
    let reg;
    if (_str) {
        // spliter || (spliter = '-');
        reg = new RegExp(spliter, 'g');
        _str.replace(reg, '/');
        try {
            return Date.parse(_str);
        } catch (e) {
            return '';
        }
    }
};
const getTimeLineInfo = (departure: string, arrival: string) => {
    let departureInfo;
    let arrivalInfo;
    const result = [];
    const dateReg = /^\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}:\d{2}$/;
    if (departure && arrival && dateReg.test(departure) && dateReg.test(arrival)) {
        departureInfo = departure.trim().split(' ');
        arrivalInfo = arrival.trim().split(' ');
        result.push(departureInfo[0] || '');
        result.push((departureInfo[1] && departureInfo[1].slice(0, -3)) || '');
        result.push(arrivalInfo[0] || '');
        result.push((arrivalInfo[1] && arrivalInfo[1].slice(0, -3)) || '');
    }
    return result;
};
const buildMixUpInfo = (mixUp: { departures: InfoMode[]; arrivals: InfoMode[] }) => {
    // const me = this;
    let _mixUpInfo: InfoMode[] = [];
    let departures: InfoMode[];
    let arrivals: InfoMode[];
    if (mixUp) {
        departures = [];
        arrivals = [];
        if (mixUp.departures) {
            mixUp.departures.forEach((info: InfoMode) => {
                if (info) {
                    info.timeLine = bulidMixTimeLine(info.start, info.end, true);
                    info.departures = true;
                    info.crossDay = !!info.days;
                    info.addOrMinus = info.days > 0 ? '+' : '';
                    departures.push(info);
                }
            });
        }

        if (mixUp.arrivals) {
            mixUp.arrivals.forEach((info: InfoMode) => {
                if (info) {
                    info.timeLine = bulidMixTimeLine(info.start, info.end, false);
                    info.arrivals = true;
                    info.crossDay = !!info.days;
                    info.addOrMinus = info.days > 0 ? '+' : '';
                    arrivals.push(info);
                }
            });
        }
        _mixUpInfo = _mixUpInfo.concat(departures, arrivals);
    }

    return _mixUpInfo;
};
const bulidMixTimeLine = (departure: string, arrival: string, isDeparture: boolean) => {
    const timeLineInfo = getTimeLineInfo(departure, arrival);
    if (timeLineInfo?.length) {
        return `${timeLineInfo[0] +
            (isDeparture ? ' 起飞时段 ' : ' 到达时段 ') +
            (timeLineInfo[1] || '')}~${timeLineInfo[3] || ''}`;
    }
    return '';
};
const bulidMixTimeLineMore = (mixUpInfo: any[]) => {
    let firstDeparturesTimeLine = true;
    let firstArrivalsTimeLine = true;
    for (const item of mixUpInfo) {
        if (item.departures && item.timeLine) {
            if (!firstDeparturesTimeLine) {
                item.firstDeparturesTimeLine = false;
                item.timeLine = `或 ${item.timeLine.slice(16, 27)}`;
            }
            firstDeparturesTimeLine = false;
        } else if (item.arrivals && item.timeLine) {
            if (!firstArrivalsTimeLine) {
                item.firstArrivalsTimeLine = false;
                item.timeLine = `或 ${item.timeLine.slice(16, 27)}`;
            }
            firstArrivalsTimeLine = false;
        }
    }
    return mixUpInfo;
};
/*
 json对象数组去重
 @params:array//数组对象
 @params:field//去重根据的字段
 @return:array //去重后的数组
 */
const jsonArrayUnique = (array:any, field:any) => {
    if (!(array instanceof Array || (!(array instanceof Object) && (Object.prototype.toString.call((array)) == '[object Array]') || typeof array.length == 'number' && typeof array.splice != 'undefined' && typeof array.propertyIsEnumerable != 'undefined' && !array.propertyIsEnumerable('splice')))) {
        // throw 'first params is not an array';
        return array;
    }
    else if (array[0][field]==undefined){
        var error=field+ ' is not defined for object in array';
        // throw error;
        return array;
    }
    else {
        var r = [];
        for (var i = 0; i < array.length; i++) {
            var flag = false;
            for (var j = 0; j < r.length; j++) {
                if (r[j][field] == array[i][field]) {
                    flag = true;
                    break;
                }
            }
            if (!flag) {
                r.push(array[i]);
            }
        }
        return r;
    }
}
export default {
    fixPrice,
    buildDateTime,
    buildActionInfos,
    checkDisable,
    getDetailSchema,
    buildTimeLine,
    buildFuzzyTimeLine,
    parseStr,
    getTimeLineInfo,
    buildMixUpInfo,
    bulidMixTimeLine,
    bulidMixTimeLineMore,
    jsonArrayUnique
};

interface InfoMode {
    start: string;
    end: string;
    timeLine: string;
    departures: boolean;
    crossDay: boolean;
    addOrMinus: string;
    days: number;
    arrivals: boolean;
}
